import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import MODALS from 'constants/layout/modals'
import { Note } from 'components/misc'

export default class InfoAssessorModal extends Component {
render() {
    return (
      <MaterialModal.Body
        id={MODALS.INFO_ASSESSOR}
        narrow noHeader
      >
        <MaterialModal.Content noFooter noHeader>
          <Note intlKey='label.assessor_details'>
            An assessor checks on participant progress and agrees on the completion of a section
            of selected activity of the Program. An Assessor can be anyone who is interested in
            helping others to achieve their goal, has some knowledge of the activity their participants
            are doing and can be available to provide assessment of the effort at the end of the activity.
            Your assessment will be requested by another email for activity sign-off.
          </Note>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
